<template>
  <div class="admin-page__detail admin-customTablesWrapper">
    <div class="bv-example-row">
      <div class="row">
        <div class="d-none d-md-block d-lg-flex col-md-4 col-lg-3 col-12">
          <div class="layout__box admin-page__box admin-page__box--detail">
            <AppBack :black="true" :route="menuRoute" :text="'zpet'" />
            <ProjectMenu @open-new="toggleNewModal('newProject')" />
          </div>
        </div>
        <div class="col-md-8 col-lg-9 col-12">
          <AppBack :black="true" :route="menuRoute" :text="'zpet'" class="d-md-none mb-0" />
          <div class="layout__content__content layout__content__content--white border-radius pt-5 h-100">
            <RouterView :key="$route.fullPath" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="openedNew.length > 0">
      <div>
        <ProjectNew
          :opened="openedNew"
          @close-box="toggleNewModal"
          @open-box="toggleNewModal"
          @reload-projects="reloadProjects"
        />
      </div>
    </div>
  </div>
</template>

<script>
//import axios from "axios";
import Back from "@/components/back.vue"
//import Select from "@/components/inputs/select.vue";
import Menu from "@/components/admin/project/menu.vue"
import ProjectNew from "@/components/modals/admin/project/newProject.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    AppBack: Back,
    ProjectMenu: Menu,
    ProjectNew
  },
  props: {
    item: Object,
    selectedSubmenu: Number
  },
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      customerId: this.$router.currentRoute.value.params.customerId,
      selectedProject: {},
      submenu: 1,
      openedNew: []
    }
  },
  computed: {
    menuRoute() {
      // projectId is optional on the admin menu route; keep it out of the path when unset.
      return this.projectId ? `/admin/menu/${this.customerId}/${this.projectId}` : `/admin/menu/${this.customerId}`
    },
    // The store, not the route param, knows whether the project still exists.
    projectId() {
      return this.projectStore.selectedProject?.projectId || ""
    },
    projects() {
      return this.projectStore.projectList
    }
  },
  watch: {
    projects() {
      /*this.item ? this.selectedProject = this.item : this.selectedProject = this.projects[0];*/
    }
    /*selectedProject() {
      this.$store.dispatch("admin/setProject", {
        project: this.selectedProject
      });
    }*/
  },
  mounted() {
    /*if(this.projects) {
      this.storedProject ? this.selectedProject = this.storedProject : this.selectedProject = this.projects[0];
      if(this.storedProject) {
        this.selectedProject = this.storedProject
      } else {
        var prj = localStorage.getItem("selectedAdminProject");

        this.selectedProject = prj != undefined ? JSON.parse(prj) : this.projects[0];
      }
    }*/
  },
  methods: {
    selectProject(project) {
      this.selectedProject = project
    },
    selectSubmenu(submenu) {
      this.$emit("changeSubmenu", submenu)
      this.submenu = submenu
    },
    toggleNewModal(box) {
      if (this.openedNew.indexOf(box) > -1) {
        box == undefined ? (this.openedNew = []) : this.openedNew.splice(this.openedNew.indexOf(box), 1)
      } else {
        this.openedNew.push(box)
      }
    },
    reloadProjects() {
      this.projectStore.getProjectList()
    }
  }
}
</script>

<style lang="scss" scoped></style>
